import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentinkharadipune() {



  const cardData = {
"keyword": "Tempo Traveller on Rent in Kharadi Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Tempo Traveller on Rent in Kharadi, Pune for corporate travel, IT staff transportation, family trips, weddings, airport transfers, and outstation group tours. Our fleet includes 9, 12, 14, 17, 20, and 26-seater Tempo Travellers with AC, pushback seats, spacious interiors, and professional drivers experienced in Kharadi and Pune city routes. We ensure safe, punctual, and comfortable group travel with doorstep pickup from Kharadi, EON IT Park, World Trade Center, and nearby areas.",

"topPlaces": [

{
"title": "Harihareshwar",
"description":
"Harihareshwar is a coastal pilgrimage and beach destination known as 'Dakshin Kashi'. It is popular for temple visits, beaches, and group tours from Pune."
},
{
"title": "Diveagar",
"description":
"Diveagar is a clean and less crowded beach destination known for coconut trees, calm waters, and peaceful group outings from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a scenic hill station known for Arthur Lake, Randha Falls, and beautiful monsoon views. It is a popular weekend group trip destination from Pune."
},
{
"title": "Ellora Caves",
"description":
"Ellora Caves is a UNESCO World Heritage site near Aurangabad famous for rock-cut temples, sculptures, and ancient Indian architecture. It is a popular long-distance group travel destination from Pune for history and heritage tours."
},
{
"title": "Ajanta Caves",
"description":
"Ajanta Caves are UNESCO-listed Buddhist caves known for ancient paintings, carvings, and historical significance. It is a top cultural and heritage group tour destination from Pune."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for viewpoints, toy train rides, and lush greenery. It is ideal for peaceful group trips from Pune."
},
{
"title": "Amboli",
"description":
"Amboli is a hill station in the Sahyadri range famous for waterfalls, mist, and green valleys. It is ideal for nature and monsoon group tours from Pune."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular long-road group travel destination from Pune."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city known for lakeside promenade, colorful architecture, cafes, and leisure activities. It is a popular short group trip destination from Pune."
},
{
"title": "Karnala Bird Sanctuary",
"description":
"Karnala Bird Sanctuary is a protected forest area near Mumbai known for trekking, birdwatching, and nature trails. It is ideal for adventure group trips from Pune."
}
],



services: [
  {
    name: "14 Seater Tempo Traveller Kharadi",
    description: "14 seater Tempo Traveller Kharadi service provides comfortable transportation for airport transfers, corporate travel, sightseeing tours, family outings, and outstation journeys. Spacious seating and luggage space ensure smooth travel experiences suitable for medium-sized passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial areas across Kharadi Pune. Flexible booking options allow convenient 14 seater traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller Kharadi",
    description: "17 seater Tempo Traveller Kharadi service offers spacious transportation for employee outings, pilgrimage journeys, educational tours, family vacations, and tourist travel. Comfortable seating and smooth highway performance ensure pleasant travel experiences suitable for larger passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial areas across Kharadi Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "20 Seater Tempo Traveller Kharadi",
    description: "20 seater Tempo Traveller Kharadi service provides reliable transportation for corporate events, airport transfers, wedding functions, office outings, and group travel requirements. Spacious interiors and luggage capacity ensure comfortable journeys suitable for medium and large passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial locations across Kharadi Pune. Flexible booking options allow convenient 20 seater traveller reservations."
  },
  {
    name: "Tempo Traveller for Corporate Kharadi",
    description: "Tempo Traveller for corporate Kharadi service offers professional transportation for business meetings, office outings, conferences, employee travel, and executive journeys. Spacious seating and smooth travel performance ensure comfortable experiences suitable for IT professionals and office teams. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial locations across Kharadi Pune. Flexible booking options allow convenient corporate traveller reservations."
  },
  {
    name: "Tempo Traveller for IT Park Kharadi",
    description: "Tempo Traveller for IT park Kharadi service provides dependable transportation for employee movement, office shuttle services, airport transfers, company outings, and business travel. Spacious seating and comfortable interiors ensure smooth journeys suitable for IT professionals and executive teams. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial areas across Kharadi Pune. Flexible booking options allow convenient IT park traveller reservations."
  },
  {
    name: "Tempo Traveller for Wedding Kharadi",
    description: "Tempo Traveller for wedding Kharadi service offers stylish transportation for bridal parties, wedding guests, family members, and marriage event travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding ceremonies and celebrations. Professional drivers ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, and residential areas across Kharadi Pune. Flexible booking options allow convenient wedding traveller reservations."
  },
  {
    name: "Tempo Traveller for Airport Pickup Kharadi",
    description: "Tempo Traveller for airport pickup Kharadi service provides reliable transportation for tourists, business travelers, wedding groups, and family passengers traveling to and from airport terminals. Spacious seating and luggage capacity ensure comfortable airport journeys suitable for all passenger groups. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and Pune Airport across Kharadi Pune. Flexible booking options allow convenient airport traveller reservations."
  },
  {
    name: "Tempo Traveller for Outstation Kharadi",
    description: "Tempo Traveller for outstation Kharadi service offers dependable long-distance transportation for Goa tours, pilgrimage journeys, family vacations, sightseeing trips, and tourist travel. Spacious seating and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial areas across Kharadi Pune. Flexible booking options allow convenient outstation traveller reservations."
  },
  {
    name: "Kharadi to Shirdi Tempo Traveller",
    description: "Kharadi to Shirdi Tempo Traveller service provides comfortable transportation for Sai Baba darshan tours, pilgrimage journeys, family trips, and spiritual group travel from Kharadi Pune. Spacious seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from IT parks, homes, offices, hotels, and commercial areas across Kharadi Pune. Flexible booking options allow convenient Shirdi traveller reservations."
  },
  {
    name: "Kharadi to Mumbai Tempo Traveller",
    description: "Kharadi to Mumbai Tempo Traveller service offers reliable long-distance transportation for corporate travel, sightseeing journeys, airport transfers, family trips, and tourist travel. Spacious seating and smooth expressway travel ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial locations across Kharadi Pune. Flexible booking options allow convenient Mumbai traveller reservations."
  },
  {
    name: "Kharadi to Lonavala Tempo Traveller",
    description: "Kharadi to Lonavala Tempo Traveller service provides comfortable hill station transportation for sightseeing tours, family vacations, office outings, and weekend trips from Kharadi Pune. Spacious interiors and smooth expressway travel ensure pleasant journeys suitable for tourist and corporate groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial locations across Kharadi Pune. Flexible booking options allow convenient Lonavala traveller reservations."
  },
  {
    name: "Kharadi to Mahabaleshwar Tempo Traveller",
    description: "Kharadi to Mahabaleshwar Tempo Traveller service offers dependable transportation for hill station vacations, sightseeing tours, family outings, and tourist travel from Kharadi Pune. Spacious seating and smooth ghat road travel ensure comfortable journeys suitable for family and corporate groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial areas across Kharadi Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
  },
  {
    name: "Kharadi to Goa Tempo Traveller",
    description: "Kharadi to Goa Tempo Traveller service provides premium long-distance transportation for beach vacations, sightseeing tours, bachelor trips, and family holidays from Kharadi Pune. Spacious seating and luggage capacity ensure smooth highway journeys suitable for tourist and group travel requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Goa route. Pickup services are available from IT parks, homes, offices, hotels, and commercial locations across Kharadi Pune. Flexible booking options allow convenient Goa traveller reservations."
  },
  {
    name: "Luxury Tempo Traveller Kharadi",
    description: "Luxury Tempo Traveller Kharadi service offers premium transportation for weddings, corporate events, airport transfers, sightseeing tours, and family vacations. Spacious luxury interiors and elegant seating ensure smooth travel experiences suitable for executive passengers and tourist groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, railway stations, and airports across Kharadi Pune. Flexible booking options allow convenient luxury traveller reservations."
  },
  {
    name: "AC Tempo Traveller Kharadi",
    description: "AC Tempo Traveller Kharadi service provides premium air-conditioned transportation for business travel, educational tours, airport transfers, office outings, and outstation journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, railway stations, and airports across Kharadi Pune. Flexible booking options allow convenient AC traveller reservations."
  },
  {
    name: "Non AC Tempo Traveller Kharadi",
    description: "Non AC Tempo Traveller Kharadi service offers affordable transportation for educational tours, local sightseeing, office travel, school trips, and group journeys. Spacious seating and smooth travel ensure comfortable experiences suitable for budget-friendly travel requirements. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial locations across Kharadi Pune. Flexible booking options allow convenient non AC traveller reservations."
  },
  {
    name: "Affordable Tempo Traveller Kharadi",
    description: "Affordable Tempo Traveller Kharadi service provides economical transportation for family outings, school trips, office travel, sightseeing tours, weddings, and local or outstation journeys. Spacious seating and luggage capacity ensure comfortable travel experiences suitable for all passenger groups and travel requirements. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, and residential areas across Kharadi Pune. Flexible booking options allow convenient affordable traveller reservations."
  },
  {
    name: "Tempo Traveller Hire Wagholi Kharadi Belt",
    description: "Tempo Traveller hire Wagholi Kharadi belt service offers dependable transportation for airport transfers, office outings, sightseeing tours, family functions, and outstation travel. Spacious seating and smooth travel performance ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, and residential areas across Wagholi and Kharadi Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller Hire Viman Nagar Nearby",
    description: "Tempo Traveller hire Viman Nagar nearby service provides reliable transportation for airport travel, office outings, educational tours, sightseeing journeys, and family functions. Spacious seating and luggage capacity ensure smooth travel experiences suitable for local and long-distance journeys. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, Pune Airport, and commercial areas across Viman Nagar Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller Hire Hadapsar Nearby",
    description: "Tempo Traveller hire Hadapsar nearby service offers comfortable transportation for weddings, corporate travel, airport transfers, family outings, and sightseeing journeys from Hadapsar Pune. Spacious interiors and smooth travel performance ensure pleasant journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Hadapsar Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller for Group Tour Kharadi",
    description: "Tempo Traveller for group tour Kharadi service provides spacious transportation for educational tours, tourist travel, office outings, sightseeing journeys, and pilgrimage trips. Comfortable seating and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, railway stations, and airports across Kharadi Pune. Flexible booking options allow convenient group tour traveller reservations."
  },
  {
    name: "Tempo Traveller for Family Trip Kharadi",
    description: "Tempo Traveller for family trip Kharadi service offers dependable transportation for holiday vacations, sightseeing journeys, pilgrimage tours, and group travel with relatives and family members. Spacious seating and luggage space ensure smooth travel experiences suitable for local and outstation family trips. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Kharadi Pune. Flexible booking options allow convenient family trip traveller reservations."
  },
  {
    name: "Tempo Traveller for Corporate Travel Kharadi",
    description: "Tempo Traveller for corporate travel Kharadi service provides professional transportation for employee movement, business meetings, conferences, office outings, and executive travel. Spacious seating and comfortable interiors ensure smooth journeys suitable for IT professionals and office teams. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial locations across Kharadi Pune. Flexible booking options allow convenient corporate traveller reservations."
  },
  {
    name: "Tempo Traveller for Picnic Kharadi",
    description: "Tempo Traveller for picnic Kharadi service offers affordable transportation for school outings, office trips, family gatherings, sightseeing journeys, and recreational travel. Spacious seating and smooth travel ensure comfortable experiences suitable for all age groups and passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, and residential areas across Kharadi Pune. Flexible booking options allow convenient picnic traveller reservations."
  },
  {
    name: "Tempo Traveller Rental Per KM Kharadi",
    description: "Tempo Traveller rental per km Kharadi service provides flexible and economical transportation for airport transfers, sightseeing tours, business travel, educational trips, and local group journeys. Spacious seating and comfortable interiors ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Kharadi Pune. Flexible booking options allow convenient per km traveller reservations."
  }
],

tableData: [
  ["14 Seater Tempo Traveller Kharadi", "17 Seater Tempo Traveller Kharadi"],
  ["20 Seater Tempo Traveller Kharadi", "Tempo Traveller for Corporate Kharadi"],
  ["Tempo Traveller for IT Park Kharadi", "Tempo Traveller for Wedding Kharadi"],
  ["Tempo Traveller for Airport Pickup Kharadi", "Tempo Traveller for Outstation Kharadi"],
  ["Kharadi to Shirdi Tempo Traveller", "Kharadi to Mumbai Tempo Traveller"],
  ["Kharadi to Lonavala Tempo Traveller", "Kharadi to Mahabaleshwar Tempo Traveller"],
  ["Kharadi to Goa Tempo Traveller", "Luxury Tempo Traveller Kharadi"],
  ["AC Tempo Traveller Kharadi", "Non AC Tempo Traveller Kharadi"],
  ["Affordable Tempo Traveller Kharadi", "Tempo Traveller Hire Wagholi Kharadi Belt"],
  ["Tempo Traveller Hire Viman Nagar Nearby", "Tempo Traveller Hire Hadapsar Nearby"],
  ["Tempo Traveller for Group Tour Kharadi", "Tempo Traveller for Family Trip Kharadi"],
  ["Tempo Traveller for Corporate Travel Kharadi", "Tempo Traveller for Picnic Kharadi"],
  ["Tempo Traveller Rental Per KM Kharadi", "14 Seater Tempo Traveller Kharadi"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Tempo Traveller on Rent in Kharadi Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Tempo Traveller rental service in Kharadi Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate trips, family tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable Tempo Traveller Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Tempo Traveller on rent in Kharadi Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our Tempo Traveller rental service in Kharadi Pune operates 24 hours for airport transfers, employee transportation, weddings, pilgrimage tours, corporate outings, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, corporate outings, pilgrimage journeys, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, and 20 seater Tempo Travellers suitable for office teams, family groups, wedding travel, tourists, and employee transportation."
      },
      {
        WhyChooseheading: "Quick Pickup Service in Kharadi & Nearby Areas",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Kharadi, EON IT Park, World Trade Center, Chandan Nagar, Wagholi, Viman Nagar, Magarpatta, and Pune Airport for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Tempo Traveller on rent in Kharadi Pune?", answer: "Tempo Traveller rental service in Kharadi Pune provides comfortable group transportation for corporate travel, family tours, weddings, and outstation journeys." },
    { question: "Is Tempo Traveller booking available 24 hours in Kharadi?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller rental service in Kharadi Pune." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group travel requirements." },
    { question: "Can I book Tempo Traveller for outstation travel from Kharadi?", answer: "Yes, customers can book Tempo Travellers for outstation tours, hill station trips, pilgrimage journeys, and holiday travel from Kharadi Pune." },
    { question: "Do you provide Tempo Travellers for corporate events in Kharadi?", answer: "Yes, Aaradhya Travels provides Tempo Traveller rental service for corporate meetings, office outings, conferences, and employee transportation in Kharadi." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book Tempo Traveller online in Kharadi Pune?", answer: "Yes, customers can easily book Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for weddings, family vacations, and group tours." },
    { question: "Are Tempo Traveller rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Tempo Traveller rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, corporate events, and peak travel periods." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback:
      "Group travel from Kharadi Pune was handled very smoothly with Aaradhya Travels providing a Tempo Traveller. The journey was comfortable, and everyone could travel together without any coordination issues.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rutuja Kulkarni",
    feedback:
      "Aaradhya Travels arranged a Tempo Traveller on rent in Kharadi Pune for our family function, and the experience was very well managed. The vehicle was clean, spacious, and the ride remained comfortable throughout.",
    rating: 5
  }
];



  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller on Rent in Kharadi Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/tempo-traveller-on-rent-in-kharadi.jpg",
  "description": "Book Tempo Traveller on rent in Kharadi Pune with Aaradhya Travels for corporate travel, IT park transport, weddings, airport transfers, family trips, and outstation journeys. Available in 14, 17, and 20 seater options across Kharadi, Viman Nagar, and nearby areas.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3592"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/tempo-traveller-on-rent-in-kharadi"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Tempo Traveller on Rent in Kharadi Pune | IT & Corporate Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Tempo Traveller on rent in Kharadi Pune with Aaradhya Travels. Affordable 14, 17, and 20 seater tempo traveller available for IT companies, corporate travel, airport transfers, weddings, family trips, and outstation tours."
  />

  <meta
    name="keywords"
    content="14 seater tempo traveller Kharadi, 17 seater tempo traveller Kharadi, 20 seater tempo traveller Kharadi, Tempo traveller for corporate Kharadi, Tempo traveller for IT park Kharadi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentinkharadipune;